//imgs
import img01 from "../../assets/images/chapters/04/01.jpg";
import img02 from "../../assets/images/chapters/04/02.jpg";
import img03 from "../../assets/images/chapters/04/03.jpg";
import img04 from "../../assets/images/chapters/04/04.jpg";
import img05 from "../../assets/images/chapters/04/05.jpg";
import img06 from "../../assets/images/chapters/04/06.jpg";
import img07 from "../../assets/images/chapters/04/07.jpg";
import img08 from "../../assets/images/chapters/04/08.jpg";
import img09 from "../../assets/images/chapters/04/09.jpg";
import img10 from "../../assets/images/chapters/04/10.jpg";

import { captions, list } from "../../assets/data/chapters/chapter04";

//scroll reveal
import ScrollReveal from "../scrollReveal";

const list2 = [
  { img: img02, caption: captions[4] },
  { img: img03, caption: captions[5] },
  { img: img04, caption: captions[6] },
  { img: img05, caption: captions[7] },
  { img: img06, caption: captions[8] },
  { img: img07, caption: captions[9] },
  { img: img08, caption: captions[10] },
];

const Chapter = () => {
  return (
    <div id="chapter04">
      <div className="group01">
        <ScrollReveal className="title">
          <span>TV CAMERA</span>
        </ScrollReveal>

        <div className="row">
          {list.map((elem, i) => (
            <ScrollReveal key={i} className="picture">
              <img src={elem.img} />
              {elem.caption && <p className="caption">{elem.caption}</p>}
            </ScrollReveal>
          ))}
          <ScrollReveal className="picture">
            <img src={img01} />
            <p className="caption">{captions[3]}</p>
          </ScrollReveal>
        </div>
      </div>

      <div className="group02">
        <ScrollReveal className="title">
          S-IC{"\n"}S-II{"\n"}S-IVB
        </ScrollReveal>
        <div className="row">
          {list2.map((elem, i) => (
            <ScrollReveal key={i} className="picture">
              <img src={elem.img} />
              <p className="caption">{elem.caption}</p>
            </ScrollReveal>
          ))}
        </div>
      </div>

      <div className="group03">
        <ScrollReveal className="picture">
          <img src={img09} />
          <p className="caption">{captions[11]}</p>
        </ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img10} />
          <p className="caption">{captions[12]}</p>
        </ScrollReveal>
      </div>
    </div>
  );
};

export default Chapter;
